import { PlanResolution } from '../../types';
import type { PositionError } from './types';

export const positionErrors: Record<PositionError, string> = {
  overlap: 'Positions overlap',
};

export const INNER_ROW_HEIGHT = 39;
export const INNER_HEADER_HEIGHT = 37;

// 540 955(collaopse) -317 (title) -44 -38 = ~556 @ 1024 with colapsed sidebar
export const DAY_WIDTH: Record<PlanResolution, number> = {
  DAY: 22,
  WEEK: 14, // 98px (if we go down single day becomes "undersized")
  MONTH: 2, // ~60px
};

export const HANDLE_WIDTH = 5;
export const UNDERSIZED_WIDTH = HANDLE_WIDTH * 3;
